import ContactUs from './ContactUs';

import './index.less';

const FloatCom = () => {
  return <ContactUs />;
};

export default FloatCom;
